import {client, clients, createClient, saveClient} from "../../api";
export default {
	state: {
		all: [],
		current: {}
	},
	actions: {
		fetchClients(context, settings = {paginate: false}) {
			let token = context.getters.getToken.jwt;

			return clients({ token, settings }).then(r => {
				context.commit("setClients", r.data);
			});
		},

		fetchClient(context, id) {
			let token = context.getters.getToken.jwt;

			return client({ token, client: id }).then(r => {
				context.commit("setClient", r.data);
			});
		},

		saveClient(context, client) {
			let token = context.getters.getToken.jwt;

			return saveClient({ token, client });
		},

		createClient(context, client) {
			let token = context.getters.getToken.jwt;

			return createClient({ token, client });
		}
	},
	mutations: {
		setClients(state, payload) {
			console.log("setClients payload", payload);
			state.all = payload;
		},
		setClient(state, payload) {
			console.log("setClient payload", payload);
			state.current = payload;
		}
	},
	getters: {}
};
